// import Autocomplete from "@material-ui/lab/Autocomplete";
import { Autocomplete, Box, Button, Dialog, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { useState } from "react";
import { toast } from "react-toastify";
import { dialogueColumns } from "../../../utils/Level/utils";
import { getAllVoucherDataInRange } from "../../../utils/endPoints";
import { useAppSelector } from "../../../utils/hooks";

function DialogVoucherSearch({ okCallback, cancelCallback, vtype, visible }) {
  const level3Codes = useAppSelector((state) => state.accountLevels.level3);
  const width = 1000;
  const voucherTypes = ["BPV", "BRV", "CPV", "CRV", "JV","SALE"];
  const [currentVouchers, setCurrentVouchers] = useState([]);
  const [type, setType] = useState("");
  const [amount, setAmount] = useState("");
  const [code, setCode] = useState("");
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [dateUpdate, setDateUpdated] = useState(true);
  const [filteredDataSource, setFilteredDataSource] = useState([]);

  const handleDate = (event) => {
    const nDate = moment(event);
    if (startDate != nDate) {
      setDateUpdated(true);
    }
    setStartDate(nDate);
  };

  const handleEndDate = (event) => {
    const nDate = moment(event);
    if (endDate != nDate) {
      setDateUpdated(true);
    }
    setEndDate(nDate);
  };

  const handleType = (event) => {
    setType(event.target.value);
  };

  const handleAmount = (event) => {
    setAmount(event.target.value);
  };

  const handleCode = (event) => {
    setCode(event.target.value);
  };

  const fetchVouchersDate = async () => {
    console.log("Fetching...");
    if (endDate < startDate) {
      toast.error("End date must be greater than start date.");
      return [];
    }
    if (!dateUpdate) {
      setFilteredDataSource(currentVouchers);
      return [];
    }

    let vouchersInRnge = await Promise.all(
      level3Codes.map(async (code) => {
        const allVouchersArray = await getAllVoucherDataInRange(
          code.fullcode,
          moment(startDate).format("DD-MM-YYYY"),
          moment(endDate).format("DD-MM-YYYY")
        );
        return allVouchersArray;
      })
    );
    vouchersInRnge = Object.values(vouchersInRnge).flatMap((arr) => arr);
    console.log(vouchersInRnge);
    let tempVouchersArray = [];
    let voucherId = 1;
    vouchersInRnge.forEach((element) => {
      if (
        moment(startDate).isSameOrBefore(
          moment(element.voucherDate, "DD/MM/YYYY"),
          "day"
        ) &&
        moment(endDate).isSameOrAfter(
          moment(element.voucherDate, "DD/MM/YYYY"),
          "day"
        )
      ) {
        let lock = element?.lockStatus ? "Locked" : "Unlocked";
        let l3CodesArray = [];
        // element?.voucherItemsRef.forEach(vItem => {
        //   const tempArray = vItem.split('/');
        //   let l3code = tempArray[3] + '-' + tempArray[5] + '-' + tempArray[7];
        //   l3CodesArray.push(l3code);
        // });
        // l3CodesArray.push(element.code);
        tempVouchersArray.push({
          ...element,
          id: voucherId,
          lock,
          vnumber: element.voucherNumber,
          // l3CodesArray,
        });
        voucherId = voucherId + 1;
      }

      //
    });
    //tempVouchersArray.push(singleVoucher)
    //   });
    // });
    setDateUpdated(false);
    return tempVouchersArray;
  };

  const handleDateSearch = async () => {
    if (dateUpdate) {
      const tempVouchersArray = await fetchVouchersDate();
      setCurrentVouchers(tempVouchersArray);
      setFilteredDataSource(tempVouchersArray);
    } else {
      setFilteredDataSource(currentVouchers);
    }
  };
  const handleAmountSearch = async () => {
    if (dateUpdate) {
      const tempVouchersArray = await fetchVouchersDate();
      const result = tempVouchersArray.filter((item) => item.amount == amount);
      result.forEach((element, index) => {
        result[index] = { ...element, id: index + 1 };
      });
      setFilteredDataSource(result);
    } else {
      const result = currentVouchers.filter((item) => item.amount == amount);
      result.forEach((element, index) => {
        result[index] = { ...element, id: index + 1 };
      });
      setFilteredDataSource(result);
    }
  };
  const handleCodeSearch = async () => {
    const sCode = code.split("\t")[0];

    if (dateUpdate) {
      const tempVouchersArray = await fetchVouchersDate();
      const result = tempVouchersArray.filter(
        (item) => item.l3CodesArray.indexOf(sCode) !== -1
      );
      result.forEach((element, index) => {
        result[index] = { ...element, id: index + 1 };
      });
      setFilteredDataSource(result);
    } else {
      const result = currentVouchers.filter(
        (item) => item.l3CodesArray.indexOf(sCode) !== -1
      );
      result.forEach((element, index) => {
        result[index] = { ...element, id: index + 1 };
      });
      setFilteredDataSource(result);
    }
  };
  const handleTypeSearch = async () => {
    if (dateUpdate) {
      const tempVouchersArray = await fetchVouchersDate();
      const result = tempVouchersArray.filter((item) => item.type == type);
      result.forEach((element, index) => {
        result[index] = { ...element, id: index + 1 };
      });
      setFilteredDataSource(result);
    } else {
      const result = currentVouchers.filter((item) => item.type == type);
      result.forEach((element, index) => {
        result[index] = { ...element, id: index + 1 };
      });
      setFilteredDataSource(result);
    }
  };

  const handleDoubleClick = (selectedRow) => {
    let data = { ...selectedRow };
    delete data.id;
    delete data.l3CodesArray;
    delete data.lock;
    okCallback(data);
  };

  const style = {
    display: "flex",
    flexDirection: "column",
    bgcolor: "#379683",
    justifyContent: "flex-start",
    alignItems: "center",
  };

  const styles = {
    button: {
      backgroundColor: "#379683",
      color: "white",
      marginTop: 5,
      marginBottom: 5,
      backgroundColor: "#379683",
      color: "white",
      marginTop: 5,
      marginBottom: 5,
      backgroundColor: "#379683",
      color: "white",
      marginTop: 5,
      marginBottom: 5,
    },
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"xl"}
      style={style}
      open={visible}
      onClose={cancelCallback}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          marginTop: 5,
          height: "90vh",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: width,
            backgroundColor: "#eee",
            boxShadow: "0 8px 8px -4px lightblue",
            marginBottom: 5,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignSelf: "flex-start",
              justifyContent: "flex-start",
              marginLeft: "5%",
            }}
          >
            <Box sx={{ minWidth: "25%" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            size="large"
            label="Start Date"
            value={new Date(startDate)}
            onChange={(event) => handleDate(event)}
            disableFuture
            InputProps={{ disableUnderline: true }}
          />
        </LocalizationProvider>
            </Box>
            <Box sx={{ minWidth: "25%" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  size="large"
                  label="End Date"
                  value={new Date(endDate)}
                  onChange={(event) => handleEndDate(event)}
                  disableFuture
                  InputProps={{ disableUnderline: true }}
                />
              </LocalizationProvider>
            </Box>
            <Button
              size="large"
              style={styles.button}
              onClick={handleDateSearch}
            >
              {"Search Date"}
            </Button>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            width: width,
            backgroundColor: "#eee",
            boxShadow: "0 8px 8px -4px lightblue",
          }}
        >
          <Box
            sx={{ minWidth: "50%", marginLeft: "5%", marginRight: "5%" }}
            style={{ width: "44%" }}
          >
            <Autocomplete
              onBlurCapture={handleType}
              disablePortal
              id="combo-box-Voucher-type"
              getOptionLabel={(option) => option}
              options={voucherTypes}
              renderInput={(params) => (
                <TextField {...params} label="Voucher Type" />
              )}
            />
          </Box>
          <Button size="large" style={styles.button} onClick={handleTypeSearch}>
            {"Search Date & Type"}
          </Button>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            width: width,
            backgroundColor: "#eee",
            boxShadow: "0 8px 8px -4px lightblue",
            marginTop: 5,
          }}
        >
          <Box
            sx={{ minWidth: "50%", marginLeft: "5%", marginRight: "5%" }}
            style={{ width: "44%" }}
          >
            <Autocomplete
              onBlurCapture={handleCode}
              disablePortal
              id="combo-box-code"
              getOptionLabel={(option) =>
                option.fullcode + "\t" + option.Discription
              }
              options={level3Codes}
              renderInput={(params) => <TextField {...params} label="Code" />}
            />
          </Box>
          <Button size="large" style={styles.button} onClick={handleCodeSearch}>
            {"Search Date & L3 Code"}
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            width: width,
            backgroundColor: "#eee",
            boxShadow: "0 8px 8px -4px lightblue",
            marginTop: 5,
          }}
        >
          <Box
            sx={{ minWidth: "50%", marginLeft: "5%", marginRight: "5%" }}
            style={{ width: "44%" }}
          >
            <TextField
              value={amount}
              onChange={handleAmount}
              style={{ width: "100%" }}
              required
              id="outlined-required"
              label="Amount"
              type="number"
            ></TextField>
          </Box>
          <Button style={styles.button} onClick={handleAmountSearch}>
            {"Search Date & Amount"}
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "95%",
            height: "50vh",
            backgroundColor: "#379683",
            marginTop: 10,
          }}
        >
          <DataGrid
            headerHeight={20}
            rowHeight={25}
            style={{ width: "100%" }}
            onCellClick={() => {}}
            // getRowClassName={params =>
            //   `super-app-theme--${params.getValue(
            //     params.id,
            //     'transactionType',
            //   )}`
            // }
            onCellDoubleClick={(params, event) => {
              console.log(event, params);
              if (!event.ctrlKey) {
                event.defaultMuiPrevented = true;
              }
              handleDoubleClick(params.row);
            }}
            rows={filteredDataSource}
            columns={dialogueColumns}
            pageSize={25}
            disableColumnMenu
          />
        </div>
      </div>
    </Dialog>
  );
}

export default DialogVoucherSearch;
